module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('side-bar', {
    staticClass: "menu"
  }), _vm._v(" "), _c('app-main')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c9883784!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Content.vue
// module id = 1097
// module chunks = 2